import api from "../../utils/api";
import type { IRespuestaApiObjeto } from "../../globales/interfaces";
import type { IAlertaMantenimientoACosto } from "./entidades/IAlertaMantenimientoACosto";

/** Alertas de mantenimiento a costo (/api/AlertasMantenimientoACosto). El back no restringe por rol: lo decide el front. */
export class AlertaMantenimientoACostoModelo {
    /** De la más reciente a la más antigua; sin paginación (trae todo el historial). */
    public async listar(soloNoLeidas: boolean = false): Promise<IRespuestaApiObjeto<IAlertaMantenimientoACosto[]>> {
        const { data } = await api.get<IRespuestaApiObjeto<IAlertaMantenimientoACosto[]>>(
            `/api/AlertasMantenimientoACosto/Listar`, { params: soloNoLeidas ? { soloNoLeidas: true } : undefined });
        return data;
    }

    /** Idempotente. Si la alerta no existe, el back responde NotificationType = 1 con el mensaje. */
    public async marcarLeida(id: number): Promise<IRespuestaApiObjeto<boolean>> {
        const { data } = await api.put<IRespuestaApiObjeto<boolean>>(`/api/AlertasMantenimientoACosto/MarcarLeida/${id}`);
        return data;
    }
}
